/**
 * CustomFooter — pagination footer for the Bulk Add DataGrid.
 *
 * Replaces the default MUI DataGrid footer with the app's shared
 * CustomPagination component so that page controls match the rest of
 * the application.  Page-size selector is hidden (`showPageSizeOptions:
 * false`) because the CDG query always requests a fixed page size.
 *
 * This footer is conditionally rendered by BulkSelectCourseTable — it
 * is hidden entirely when no rows are present so that pagination
 * controls don't appear over the empty-state "No results" overlay.
 *
 * All pagination values (`totalResults`, `numPages`, `page`) originate
 * from the CDG API response's `pagination` object, ensuring the footer
 * accurately reflects server-side totals even when only one page of
 * data is loaded in the DataGrid.
 */
import React from 'react'
import Box from '@mui/material/Box'
import CustomPagination from '../../../../../components/CustomTable/CustomPagination'

interface CustomFooterProps {
  totalResults: number
  numPages: number
  /** Current page (1-based, matching the app convention). */
  page: number
  pageSize: number
  onPaginationModelChange?: (model: { page: number, pageSize: number }) => void
}

const CustomFooter: React.FC<CustomFooterProps> = ({ totalResults, numPages, page, pageSize, onPaginationModelChange }) => {
  return (
    <Box sx={{
      background: '#fff',
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center'
    }}>
      <CustomPagination
        totalResults={totalResults}
        numPages={numPages}
        pageNumber={page}
        pageSize={pageSize}
        handlePageChange={p => { onPaginationModelChange?.({ page: p, pageSize }) }}
        handleRowsPerPageChange={ps => { onPaginationModelChange?.({ page: 1, pageSize: ps }) }}
        showPageSizeOptions={false}
      />
    </Box>
  )
}

export default CustomFooter
